// import Language from './Language';
import * as C from '../common/constants';
import * as ROUTES from '../common/routes';
import React from 'react';
import clsx from 'clsx';
import { COLORS, FONTS, FONT_WEIGHT } from '../common/theme';
import { EIDs } from '../common/enums';
import { getText } from '../common/utils/helpers';
import { makeStyles, createStyles, StyleRules } from '@mui/styles';
import { useNavigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import HeaderLoginButton from './HeaderLoginButton';

const IDS = [EIDs.ABOUT, EIDs.EXPEDITION, EIDs.HOW];
const URLS = {
  [EIDs.ABOUT]: ROUTES.ABOUT,
  [EIDs.EXPEDITION]: ROUTES.EXPEDITION,
  [EIDs.HOW]: ROUTES.HOW,
  [EIDs.HOME]: ROUTES.ROOT,
};

const useStyles = makeStyles(
  (theme): StyleRules =>
    createStyles({
      headerMenuContainerStyle: {
        position: 'relative',
        width: '100%',
        height: `${C.HEADER_MENU_HEIGHT}px`,
        minHeight: `${C.HEADER_MENU_HEIGHT}px`,
        display: 'flex',
        flexDirection: 'row',
        zIndex: 20,
        justifyContent: 'space-between',
        overflow: 'hidden',
      },
      leftStyle: {
        display: 'flex',
        flexDirection: 'row',
      },
      titleStyle: {
        fontWeight: FONT_WEIGHT.medium,
        fontSize: '18px',
        fontFamily: FONTS.garamond,
        color: COLORS.appBlue,
        whiteSpace: 'nowrap',
        padding: '18px 30px',
        background: COLORS.appMenuSand,
        borderTopLeftRadius: '8px',
        borderTopRightRadius: '8px',
        textTransform: 'uppercase',
        boxShadow: '0px 3px 6px rgba(0,0,0,.16)',
        cursor: 'pointer',
        '@media (hover: hover) and (pointer: fine)': {
          '&:hover': {
            color: COLORS.appBlack,
            background: COLORS.appMenuHoverSand,
            transition: '0.5s ease',
          },
        },
      },
      activeStyle: {
        pointerEvents: 'none',
        background: COLORS.appMenuHoverSand,
      },
      [`@media (max-width: 720px)`]: {
        headerMenuContainerStyle: {
          height: 'unset',
          overflow: 'unset',
        },
        leftStyle: {
          width: '100%',
          // flexDirection: 'column',
          flexWrap: 'wrap',
        },
        titleStyle: {
          borderRadius: 0,
          fontSize: '14px',
          width: '50%',
          boxSizing: 'border-box',
        },
      },
      [`@media (max-width: 600px)`]: {
        titleStyle: {
          padding: '16px 20px',
        },
      },
      [`@media (max-width: 320px)`]: {
        titleStyle: {
          fontSize: '12px',
          width: '50%',
          padding: '16px 20px',
        },
      },
      [`@media (max-width: 250px)`]: {
        titleStyle: {
          fontSize: '12px',
          width: '100%',
        },
      },
    })
);

const HeaderMenu = (): JSX.Element => {
  const classes = useStyles();
  const navigate = useNavigate();
  const { search, pathname } = useLocation();
  const lng = useSelector((state: any) => state.app.lng);
  const appData = useSelector((state: any) => state.app.appData);

  if (!appData) {
    return null;
  }

  const menuData = appData?.filter((item) => IDS.includes(item.content.uid));

  const onClick = (event: React.SyntheticEvent) => {
    event.stopPropagation();
    event.preventDefault();

    const uid = event.currentTarget.getAttribute('data-name');
    navigate({ pathname: URLS[uid], search });
  };

  const getContent = (item, index) => {
    const title: string = getText(item?.content, 'title', lng);
    const zIndex = menuData.length - index;
    const uid = item.content.uid;

    const isActive = pathname === URLS[uid];

    return (
      <div
        className={clsx(classes.titleStyle, isActive && classes.activeStyle)}
        key={index}
        style={{ zIndex }}
        data-name={uid}
        onClick={onClick}
      >
        {title}
      </div>
    );
  };

  const getHomeButton = () => {
    const zIndex = 0;

    return (
      <div
        className={classes.titleStyle}
        style={{ zIndex }}
        data-name={EIDs.HOME}
        onClick={onClick}
      >
        {'UZ SĀKUMU'}
      </div>
    );
  };

  const isRoot = pathname === ROUTES.ROOT;

  return (
    <div className={classes.headerMenuContainerStyle}>
      <div className={classes.leftStyle}>
        {menuData.map(getContent)}
        {!isRoot && getHomeButton()}
      </div>
      <HeaderLoginButton />
    </div>
  );
};

export default HeaderMenu;
